/**
 * Version produit affichée par Tosho.
 *
 * La nomenclature officielle courante est documentée dans
 * `docs/reference/TOSHO_Versioning_reference_2026-09-11.md`.
 *
 * Cette constante est volontairement distincte des versions SemVer des paquets npm du monorepo :
 * elle identifie l'environnement, la génération produit, le Sprint, le lot et la dernière PR
 * incluse dans le déploiement. La valeur #445 devient exacte sur DEV après fusion de la PR #445
 * et déploiement du SHA de `main` qui la contient.
 */
export const TOSHO_PRODUCT_VERSION = 'D00.06.04#445' as const;
